import {Node} from '@tiptap/pm/model';
import {getText, getSchema, JSONContent} from '@tiptap/core';
import StarterKit from '@tiptap/starter-kit';
import {Color, TextStyle} from '@tiptap/extension-text-style';

export const rtf_color_dict = {
  red: '#e52207',
  green: '#538200',
  blue: '#0076d6',
};

// Migrate remirror color marks to tiptap
function convertColorMarks(content: JSONContent[]) {
  if (!Array.isArray(content)) return;

  for (const item of content) {
    if (Array.isArray(item.marks)) {
      for (const mark of item.marks) {
        if (mark.type == 'textColor') {
          mark.type = 'textStyle';
          if (typeof mark.attrs?.color == 'string') {
            const color = rtf_color_dict[mark.attrs.color as keyof typeof rtf_color_dict];
            if (color) mark.attrs.color = color;
          }
        }
      }
    }
    if (Array.isArray(item.content)) {
      convertColorMarks(item.content);
    }
  }
}

export function parseProsemirrorState(content: string) {
  if (!content) return null;

  try {
    const state = JSON.parse(content) as JSONContent;
    if (state.content) convertColorMarks(state.content);
    return state;
  } catch {
    // assume plain text
    return {
      type: 'doc',
      content: [
        {
          type: 'paragraph',
          content: [
            {
              type: 'text',
              text: content,
            },
          ],
        },
      ],
    };
  }
}

// Only extensions that affect schema are necessary here
export const prosemirror_schema = getSchema([StarterKit, Color, TextStyle]);

export function convertRtfToText(content: string) {
  const parsed_state = content ? parseProsemirrorState(content) : null;
  const node = parsed_state ? Node.fromJSON(prosemirror_schema, parsed_state) : null;
  return node ? getText(node) : null;
}
